module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedi"
  }, [_vm._v("For")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("my beaus,")]), _vm._v(" "), _c('p', {
    staticClass: "dedib"
  }, [_vm._v("Samuel Brown")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("Fred Bryant")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("Oscar Byrd")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("Malik Dawkins")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("Seth Fallen")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("Anthony Glover")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("Aaron Heyward")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("Dorian Lee")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("Angelo Matos")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("Brandon Roberts")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("Zachary Shelton")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("Cedric Trussell")]), _vm._v(" "), _c('p', {
    staticClass: "dedib"
  }, [_vm._v("You are true gentlemen destined for greatness.")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("Stay on your knees so that God can take you soaring!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8380890","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedi.vue
// module id = 66
// module chunks = 0